export const BaseURL: string = "https://addyou.se/";
export const BaseURLWww: string = "https://www.addyou.se/";

export const COLOR_RED = "#ff0000";
export const COLOR_YELLOW = "#ffce00";
export const COLOR_GREEN = "#3fa149";
export const COLOR_GRAY = "#494f56";

export const PERCENT_RED = 30;
export const PERCENT_YELLOW = 50;

export const COLOR_PALETTE = [
  "#5296f3",
  "#db6bb4",
  "#5ee3a1",
  "#ffbc5d",
  "#ff0180",

  "#110097",
  "#dd2230",
  "#f96c05",
  "#49b93a",
  "#008f96",

  "#3c0196",
  "#662d91",
  "#df41d1",
  "#db4e23",
  "#f79b0b",
  "#f8e94d",
  "#87c130",
  "#87c130",
];

export type ConfigMap = { [key: string]: string };

export const Paths: ConfigMap = {
  LANDING_PAGE: "/",
  ABOUT: "/about",
  SIGNIN: "/login",
  RESET_PASSWORD: "/reset-password",
  VERIFY: "/verify",
  PRIVACY_POLICY: "/privacy-policy",
  PRIVACY_POLICY_ADVANCE_YOU: "/advance-you-privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  TERMS_AND_CONDITIONS_ADVANCE_YOU: "/advance-you-terms-and-conditions",
  INTEGRITETSPOLICY: "/integritetspolicy",
  INTEGRITETSPOLICY_ADVANCE_YOU: "/advance-you-integritetspolicy",
  ACCOUNT: "/account",
  HOMES: "/homes",
  STAFF: "/staff",
  USERS: "/users",
  USERS2: "/users2",
  ADD_USERS2: "/users2/add",
  EDIT_USERS2: "/users2/edit/:id",
  EMPLOYEES: "/employees",
  CREATE_EMPLOYEES: "/employees/create",
  EDIT_EMPLOYEES: "/employees/edit/:id",
  AWARDS: "/awards",
  AWARD_WINNERS: "/awards/:id/winners",
  STATISTICS: "/statistics",
  HR_STATISTICS: "/hr-statistics",
  CALENDAR_AGENDA: "/calendar",
  CALENDAR2: "/calendar2",
  ORGANISATION: "/organisation",
  ADD_ORGANISATION: "/organisation/add",
  EDIT_ORGANISATION: "/organisation/edit/:id",
  SUB_ORGANISATIONS: "/sub-organisations",
  ADD_SUB_ORGANISATIONS: "/sub-organisations/add",
  EDIT_SUB_ORGANISATIONS: "/sub-organisations/edit/:id",
};

export const VALID_PATHS = Object.keys(Paths).map((key) => Paths[key]);

export const TopMenuAll: ConfigMap = {
  home: Paths.LANDING_PAGE,
  about: Paths.ABOUT,
};
export const TopMenuSuperAdmin: ConfigMap = {
  organisation: Paths.ORGANISATION,
  sub_organisations: Paths.SUB_ORGANISATIONS,
  // account: Paths.ACCOUNT,
  // homes: Paths.HOMES,
  // staff: Paths.STAFF,
  employees: Paths.EMPLOYEES,
  // users: Paths.USERS,
  users2: Paths.USERS2,
  awards: Paths.AWARDS,
  // calendar: Paths.CALENDAR_AGENDA,
  // calendar2: Paths.CALENDAR2,
  statistics: Paths.STATISTICS,
};

export const TopMenuAccountAdmin: ConfigMap = {
  organisation: Paths.ORGANISATION,
  sub_organisations: Paths.SUB_ORGANISATIONS,
  // account: Paths.ACCOUNT,
  // homes: Paths.HOMES,
  // staff: Paths.STAFF,
  employees: Paths.EMPLOYEES,
  // users: Paths.USERS,
  users2: Paths.USERS2,
  awards: Paths.AWARDS,
  // calendar: Paths.CALENDAR_AGENDA,
  // calendar2: Paths.CALENDAR2,
  statistics: Paths.STATISTICS,
};

export const TopMenuOperationsManager: ConfigMap = {
  sub_organisations: Paths.SUB_ORGANISATIONS,
  // homes: Paths.HOMES,
  // staff: Paths.STAFF,
  employees: Paths.EMPLOYEES,
  // users: Paths.USERS,
  users2: Paths.USERS2,
  awards: Paths.AWARDS,
  // calendar: Paths.CALENDAR_AGENDA,
  // calendar2: Paths.CALENDAR2,
  statistics: Paths.STATISTICS,
};

export const TopMenuHomeManager: ConfigMap = {
  // homes: Paths.HOMES,
  // staff: Paths.STAFF,
  sub_organisations: Paths.SUB_ORGANISATIONS,
  employees: Paths.EMPLOYEES,
  // users: Paths.USERS,
  users2: Paths.USERS2,
  awards: Paths.AWARDS,
  // calendar: Paths.CALENDAR_AGENDA,
  // calendar2: Paths.CALENDAR2,
  statistics: Paths.STATISTICS,
};

// SideMenu configs (same as TopMenu)
export const SideMenuAll: ConfigMap = TopMenuAll;
export const SideMenuSuperAdmin: ConfigMap = {
  ...TopMenuSuperAdmin,
  statistics: Paths.HR_STATISTICS,
};
export const SideMenuAccountAdmin: ConfigMap = {
  ...TopMenuAccountAdmin,
  statistics: Paths.HR_STATISTICS,
};
export const SideMenuOperationsManager: ConfigMap = {
  ...TopMenuOperationsManager,
  statistics: Paths.HR_STATISTICS,
};
export const SideMenuHomeManager: ConfigMap = {
  ...TopMenuHomeManager,
  statistics: Paths.HR_STATISTICS,
};

export const AuthResponse: ConfigMap = {
  USER_ALREADY_EXIST: "user-already-exists",
  USER_LOOKUP_ERROR: "user-lookup-error",
  EMAIL_PASSWORD_MISMATCH: "email-password-mismatch",
  EMAIL_NOT_VERIFIED: "email-not-verified",
  NOT_FOUND: "not-found",
  RATE_LIMIT_BLOCK: "rate-limit-block",
};

export const PASSWORD_RULES =
  "minlength: 8; maxlength: 40; required: lower; required: upper; required: digit;";

export const LS_ACCESS_TOKEN = "accesstoken";

export const ACTIVITY_PERFORMED = "performed";
export const ACTIVITY_UNABLE = "unable";
export const ACTIVITY_NOT_PERFORMED = "not_performed";

export const WELLBEING_HAPPY = "happy";
export const WELLBEING_NEUTRAL = "neutral";
export const WELLBEING_SAD = "sad";
